import GuestLayout from "./GuestLayout";

export default GuestLayout;
